import Vue from "vue";
import BootstrapVue from 'bootstrap-vue'; //marcel
import App from "./App";
import router from "./router/index";
import PaperDashboard from "./plugins/paperDashboard";
import store from "./store";
import axios from "./helpers/api";
import { createAuthFailureHandler } from "./helpers/authRefresh";

import VueI18n from 'vue-i18n';
import messages from '@/lang';

import JsonExcel from 'vue-json-excel';

import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { isMainTenant } from '@/helpers/tenants';
import { normalizeUrl } from '@/helpers/url';

Vue.prototype.$isMainTenant = isMainTenant;
Vue.prototype.$url = normalizeUrl;

Chart.defaults.global.defaultFontFamily = "'OpticSansLight','Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
Chart.defaults.global.defaultFontSize = 14;
Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
    anchor: "end",
    align: "end",
    clip: false,
    font: {
        family: "OpticSans"
    }
});

window.axios = axios;
Vue.prototype.$http = axios;

axios.interceptors.request.use(function(config) {
    const token = store.getters["auth/getToken"];
    config._authToken = token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});

axios.interceptors.response.use(
    response => response,
    createAuthFailureHandler({
        client: config => axios(config),
        getToken: () => store.getters["auth/getToken"],
        refresh: () => store.dispatch("auth/auth_refresh"),
        logout: async () => {
            await store.dispatch("auth/auth_logout");
            if (router.currentRoute.name !== "home") {
                await router.replace({ name: "home" });
            }
        }
    })
);


Vue.use(BootstrapVue); //marcel


Vue.use(PaperDashboard);


Vue.use(VueI18n);
const i18n = new VueI18n(
    {
        locale: 'pt_BR',
        fallbackLocale: 'en_US',
        messages,
    }
);

Vue.component('downloadExcel', JsonExcel)

import {
    ServerTable,
    ClientTable,
    Event
} from "vue-tables-2";
Vue.use(ServerTable, {}, false, "bootstrap4");
Vue.use(ClientTable, {}, false, "bootstrap4");

router.beforeEach((to, from, next) => {
    if (store.getters["auth/isLoggedIn"]) {
        if (to.name == "home" || to.name == "two-factor") {
            next({
                name: "dashboard"
            });
            return;
        }
        if (!store.getters["auth/getSessionRoles"]) {
            store.dispatch("auth/getSessionUser").then(() => {
                if (!(to.meta.roles instanceof Array)) {
                    next({
                        name: "dashboard"
                    });
                    return;
                }
                if (store.getters["auth/getSessionRoles"].some(v => to.meta.roles.includes(v))) {
                    next();
                } else {
                    next({
                        name: "dashboard"
                    });
                }
            });
        } else {
            if (store.getters["auth/getSessionRoles"].some(v => to.meta.roles.indexOf(v) >= 0)) {
                next();
            } else {
                if (to.name != "repairs") {
                    next({
                        name: "repairs"
                    });
                } else {
                    next();
                }
            }
        }
    } else {
        if (to.name == "two-factor") {
            if (!store.getters["auth/getPending2fa"].challenge_token) {
                next({
                    name: "home"
                });
                return;
            }
            next();
            return;
        }
        if (to.name != "home") {
            next({
                name: "home"
            });
        } else {
            next();
        }
    }
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
